// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export enum GeospatialType {
  /** Represents data in round-earth coordinate system. */
  Geography = "Geography",
  /** Represents data in Eucledian(flat) coordinate system. */
  Geometry = "Geometry",
}
